window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $('a[href*=#]').on(
      'click',
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }
    return cookieEnabled;
  },
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    var tableWrapperClass =
      typeof options.tableWrapperClass === 'undefined'
        ? ''
        : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    var iframeWrapperClass =
      typeof options.iframeWrapperClass === 'undefined'
        ? ''
        : options.iframeWrapperClass;

    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  },
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );
  },

  _onSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      'id',
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
    );

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant,
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
      // BEGIN SWATCHES
      var selector = this.originalSelectorId;
      if (variant) {
        var form = $(selector).closest('form');
        for (var i = 0, length = variant.options.length; i < length; i++) {
          var radioButton = form.find(
            '.swatch[data-option-index="' +
              i +
              '"] :radio[value="' +
              variant.options[i] +
              '"]'
          );
          if (radioButton.size()) {
            radioButton.get(0).checked = true;
          }
        }
      }
      // END SWATCHES
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },
  });

  return Variants;
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */
/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function (o) {
  var t = {
    url: !1,
    callback: !1,
    target: !1,
    duration: 120,
    on: 'mouseover',
    touch: !0,
    onZoomIn: !1,
    onZoomOut: !1,
    magnify: 1,
  };
  (o.zoom = function (t, n, e, i) {
    var u,
      c,
      a,
      r,
      m,
      l,
      s,
      f = o(t),
      h = f.css('position'),
      d = o(n);
    return (
      (t.style.position = /(absolute|fixed)/.test(h) ? h : 'relative'),
      (t.style.overflow = 'hidden'),
      (e.style.width = e.style.height = ''),
      o(e)
        .addClass('zoomImg')
        .css({
          position: 'absolute',
          top: 0,
          left: 0,
          opacity: 0,
          width: e.width * i,
          height: e.height * i,
          border: 'none',
          maxWidth: 'none',
          maxHeight: 'none',
        })
        .appendTo(t),
      {
        init: function () {
          (c = f.outerWidth()),
            (u = f.outerHeight()),
            n === t
              ? ((r = c), (a = u))
              : ((r = d.outerWidth()), (a = d.outerHeight())),
            (m = (e.width - c) / r),
            (l = (e.height - u) / a),
            (s = d.offset());
        },
        move: function (o) {
          var t = o.pageX - s.left,
            n = o.pageY - s.top;
          (n = Math.max(Math.min(n, a), 0)),
            (t = Math.max(Math.min(t, r), 0)),
            (e.style.left = t * -m + 'px'),
            (e.style.top = n * -l + 'px');
        },
      }
    );
  }),
    (o.fn.zoom = function (n) {
      return this.each(function () {
        var e = o.extend({}, t, n || {}),
          i = (e.target && o(e.target)[0]) || this,
          u = this,
          c = o(u),
          a = document.createElement('img'),
          r = o(a),
          m = 'mousemove.zoom',
          l = !1,
          s = !1;
        if (!e.url) {
          var f = u.querySelector('img');
          if (
            (f && (e.url = f.getAttribute('data-src') || f.currentSrc || f.src),
            !e.url)
          )
            return;
        }
        c.one(
          'zoom.destroy',
          function (o, t) {
            c.off('.zoom'),
              (i.style.position = o),
              (i.style.overflow = t),
              (a.onload = null),
              r.remove();
          }.bind(this, i.style.position, i.style.overflow)
        ),
          (a.onload = function () {
            function t(t) {
              f.init(),
                f.move(t),
                r
                  .stop()
                  .fadeTo(
                    o.support.opacity ? e.duration : 0,
                    1,
                    o.isFunction(e.onZoomIn) ? e.onZoomIn.call(a) : !1
                  );
            }
            function n() {
              r.stop().fadeTo(
                e.duration,
                0,
                o.isFunction(e.onZoomOut) ? e.onZoomOut.call(a) : !1
              );
            }
            var f = o.zoom(i, u, a, e.magnify);
            'grab' === e.on
              ? c.on('mousedown.zoom', function (e) {
                  1 === e.which &&
                    (o(document).one('mouseup.zoom', function () {
                      n(), o(document).off(m, f.move);
                    }),
                    t(e),
                    o(document).on(m, f.move),
                    e.preventDefault());
                })
              : 'click' === e.on
              ? c.on('click.zoom', function (e) {
                  return l
                    ? void 0
                    : ((l = !0),
                      t(e),
                      o(document).on(m, f.move),
                      o(document).one('click.zoom', function () {
                        n(), (l = !1), o(document).off(m, f.move);
                      }),
                      !1);
                })
              : 'toggle' === e.on
              ? c.on('click.zoom', function (o) {
                  l ? n() : t(o), (l = !l);
                })
              : 'mouseover' === e.on &&
                (f.init(),
                c
                  .on('mouseenter.zoom', t)
                  .on('mouseleave.zoom', n)
                  .on(m, f.move)),
              e.touch &&
                c
                  .on('touchstart.zoom', function (o) {
                    o.preventDefault(),
                      s
                        ? ((s = !1), n())
                        : ((s = !0),
                          t(
                            o.originalEvent.touches[0] ||
                              o.originalEvent.changedTouches[0]
                          ));
                  })
                  .on('touchmove.zoom', function (o) {
                    o.preventDefault(),
                      f.move(
                        o.originalEvent.touches[0] ||
                          o.originalEvent.changedTouches[0]
                      );
                  })
                  .on('touchend.zoom', function (o) {
                    o.preventDefault(), s && ((s = !1), n());
                  }),
              o.isFunction(e.callback) && e.callback.call(a);
          }),
          a.setAttribute('role', 'presentation'),
          (a.alt = ''),
          (a.src = e.url);
      });
    }),
    (o.fn.zoom.defaults = t);
})(window.jQuery);

var zoomImages = function () {
  $('.js-productZoom').each(function () {
    var parent = $(this).parent();
    $(parent).trigger('zoom.destroy');

    if ($(window).innerWidth() > 767) {
      $(parent).zoom({
        url: $(parent).attr('data-zoom'),
        touch: false,
        onZoomIn: function () {
          $(this).parent().find('.zoomImg').addClass('zoom-in');
        },
        onZoomOut: function () {
          $(this).parent().find('.zoomImg').removeClass('zoom-in');
        },
        callback: function () {
          $(this)
            .parent()
            .on('touchstart tap touchmove', function () {
              $(this).trigger('zoom.destroy');
            });
        },
      });
    }
  });
};
$(document).ready(function () {
  zoomImages();
});

theme.Product = (function () {
  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    outStock: '[data-stock-out]',
    inStock: '[data-stock-in]',
    productJson: '[data-product-json]',
    productImagesJson: '[data-productimages-json]',
    productPrice: '[data-product-price]',
    productSku: '[data-sku]',
    productInventory: '[data-inventory-quantity]',
    productInventoryNotif: '[data-inventory-notif]',
    productThumbs: '[data-product-single-thumbnail]',
    productVariantMetafieldsJson: '[data-product-variant-metafields-json]',
    singleOptionSelector: '[data-single-option-selector]',
    optionSelectedValue: '[data-option-selected-value]',
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse(
      $(selectors.productJson, this.$container).html()
    );
    this.productVariantMetafieldsObject = JSON.parse(
      $(selectors.productVariantMetafieldsJson, this.$container).html()
    );

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject,
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on(
      'variantChange' + this.namespace,
      this.updateAddToCartState.bind(this)
    );
    this.$container.on(
      'variantChange' + this.namespace,
      this.updateSKU.bind(this)
    );
    this.$container.on(
      'variantChange' + this.namespace,
      this.updateProductInventory.bind(this)
    );
    this.$container.on(
      'variantChange' + this.namespace,
      this.updateProductImages.bind(this)
    );
    this.$container.on(
      'variantPriceChange' + this.namespace,
      this.updateProductPrices.bind(this)
    );

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(
        this.$featuredImage.attr('src')
      );
      slate.Image.preload(
        this.productSingleObject.images,
        this.settings.imageSize
      );

      this.$container.on(
        'variantImageChange' + this.namespace,
        this.updateProductImage.bind(this)
      );
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function (evt) {
      var variant = evt.variant;

      if (variant) {
        //$(selectors.priceWrapper, this.$container).removeClass('hide');
        $(selectors.addToCart, this.$container).attr(
          'data-variant-id',
          variant.id
        );
      } else {
        $(selectors.addToCart, this.$container).attr('data-variant-id', 1234);
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.unavailable
        );
        //$(selectors.priceWrapper, this.$container).addClass('hide');
        $(selectors.inStock, this.$container).addClass('hide');
        $(selectors.outStock, this.$container).removeClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.addToCart
        );
        $(selectors.outStock, this.$container).addClass('hide');
        $(selectors.inStock, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        $(selectors.inStock, this.$container).addClass('hide');
        $(selectors.outStock, this.$container).removeClass('hide');
      }
      document.body.className = document.body.className.replace(
        'cart-error',
        ''
      );
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(
        selectors.comparePriceText,
        this.$container
      );
      var $productPrice = $(selectors.productPrice, this.$container);

      $(selectors.productPrice, this.$container).html(
        slate.Currency.formatMoney(variant.price, theme.moneyFormat)
      );

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(
          slate.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $compareEls.removeClass('hide');
        $productPrice.addClass('promo-price');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
        $productPrice.removeClass('promo-price');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(
        variant.featured_image.src,
        this.settings.imageSize
      );

      this.$featuredImage.attr('src', sizedImgUrl);
    },
    updateProductInventory: function (evt) {
      var variant = evt.variant;
      var quantityNotif = $(selectors.productInventoryNotif, this.$container);
      $(quantityNotif).addClass('hide');

      if (variant) {
        var variantId = 'variant-' + variant.id;
        $('#' + variantId).removeClass('hide');
      }
    },
    getSku: function (variant) {
      if (
        this.productVariantMetafieldsObject &&
        this.productVariantMetafieldsObject[variant.id] &&
        this.productVariantMetafieldsObject[variant.id]['style-number']
      ) {
        return this.productVariantMetafieldsObject[variant.id]['style-number'];
      }

      return variant.sku;
    },
    updateSKU: function (evt) {
      var variant = evt.variant;
      var $sku = $(selectors.productSku, this.$container);
      // Update the sku
      if (variant) {
        var sku = this.getSku(variant);
        $($sku).html(sku);
      }
    },
    updateProductImages: function (evt) {
      var variant = evt.variant;
      var currentVariantColor = $('.js-slickSlideProdImages').data('swatch');
      if (variant) {
        var variantColorOption = variant.option1;
        //console.log(variantColorOption);
        variantColorOption = variantColorOption
          .replace(/\s+/g, '_')
          .replace(/,/g, '_');
        //console.log(variantColorOption);
        if (currentVariantColor != variantColorOption) {
          $('.js-slickSlideProdImages').data('swatch', variantColorOption);

          var productImages = $(
            selectors.productImagesJson,
            this.$container
          ).html();
          this.productImages = JSON.parse(productImages || '{}');

          var product__slideshow = '',
            product__thumbnails = '';
          $.each(this.productImages, function (key, image) {
            if (image.src.indexOf(variantColorOption) !== -1) {
              product__slideshow +=
                '<div class="product-gallery__list-item" data-zoom="' +
                image.zoom +
                '"><img src="' +
                image.thumb +
                '" data-lazy="' +
                image.src +
                '" alt="' +
                image.alt +
                '" class="slick-lazy-image js-productZoom"></div>';
              product__thumbnails +=
                '<div><div data-product-single-thumbnail><img src="' +
                image.thumb +
                '" alt="' +
                image.alt +
                ' thumbnail"></div></div>';
            }
          });
          if ($('.pdp_video').length > 0) {
            $('.pdp_video').css('display', 'block');
            product__thumbnails +=
              '<div class="pdp_video" style="width: 100%; display: inline-block;">' +
              $('.pdp_video').html() +
              '</div>';
            product__slideshow +=
              '<div class="pdp_video" style="width: 100%; display: inline-block;">' +
              $('.pdp_video').html() +
              '</div>';
          }
          $('.js-productGallery', this.$container)
            .animate(
              {
                opacity: 0,
              },
              {
                duration: 300,
                complete: function () {
                  $('.js-slickSlideProdImages', this.$container).slick(
                    'unslick'
                  );
                  $('.js-slickSlideProdThumbs', this.$container).slick(
                    'unslick'
                  );
                  $('.js-slickSlideProdImages', this.$container).html(
                    product__slideshow
                  );
                  $('.js-slickSlideProdThumbs', this.$container).html(
                    product__thumbnails
                  );
                  initSlider();
                  zoomImages();

                  function initSlider() {
                    if (
                      $('.product__slideshow').hasClass('slick-initialized')
                    ) {
                      $('.product__slideshow').slick('unslick');
                      $('img.product__slideshow-image')
                        .parent()
                        .trigger('zoom.destroy');
                    }
                    if (
                      $('.product__thumbnails').hasClass('slick-initialized')
                    ) {
                      $('.product__thumbnails').slick('unslick');
                    }
                    initProductSlideshow($('.product__slideshow'));
                  }
                  function initProductSlideshow(productSlideshow) {
                    $('.js-slickSlideProdImages').slick({
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      arrows: false,
                      fade: true,
                      dots: false,
                      lazyLoad: 'ondemand',
                      asNavFor: '.js-slickSlideProdThumbs',
                      responsive: [
                        {
                          breakpoint: 1025,
                          settings: {
                            dots: true,
                          },
                        },
                      ],
                    });

                    $('.js-slickSlideProdThumbs').slick({
                      slidesToShow: 4,
                      slidesToScroll: 1,
                      asNavFor: '.js-slickSlideProdImages',
                      focusOnSelect: true,
                      nextArrow:
                        '<button type="button" class="slick-arrow slick-next btn"><svg width="12" height="21" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 21" aria-hidden="true"><path d="M10.5 19.5l-9-9 9-9" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/></svg><span class="visually-hidden">Next</span></button>',
                      prevArrow:
                        '<button type="button" class="slick-arrow slick-prev btn"><svg width="12" height="21" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 21" aria-hidden="true"><path d="M10.5 19.5l-9-9 9-9" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/></svg><span class="visually-hidden">Previous</span></button>',
                    });
                  }
                },
              }
            )
            .animate({
              opacity: 1,
            });
        }
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    },
  });

  return Product;
})();

$('.featured-collection-slider').slick({
  dots: true,
  infinite: false,
  touchThreshold: 10,
  nextArrow:
    '<svg class="related_products_slider_arrow_right slick-arrow slick-disabled" width="12px" height="21px" viewBox="0 0 12 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><!-- Generator: Sketch 63.1 (92452) - https://sketch.com --><title>Path 4</title><desc>Created with Sketch.</desc><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="D-/-Slider" transform="translate(-1322.000000, -216.000000)" stroke="#000000" stroke-width="2"><g id="Slider"><g id="Right-Arrow" transform="translate(1315.000000, 214.000000)"><polyline id="Path-4" transform="translate(13.000000, 12.500000) scale(-1, 1) rotate(-90.000000) translate(-13.000000, -12.500000) " points="4 17 13 8 22 17"></polyline></g></g></g></g></svg>',
  prevArrow:
    '<svg class="related_products_slider_arrow_left slick-arrow slick-disabled" width="12px" height="21px" viewBox="0 0 12 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><!-- Generator: Sketch 63.1 (92452) - https://sketch.com --><title>Path 4</title><desc>Created with Sketch.</desc><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="D-/-Slider" transform="translate(-6.000000, -216.000000)" stroke="#000000" stroke-width="2"><g id="Slider"><g id="Left-Arrow" transform="translate(12.500000, 226.500000) scale(-1, 1) translate(-12.500000, -226.500000) translate(0.000000, 214.000000)"><polyline id="Path-4" transform="translate(13.000000, 12.500000) scale(-1, 1) rotate(-90.000000) translate(-13.000000, -12.500000) " points="4 17 13 8 22 17"></polyline></g></g></g></g></svg>',
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        dots: false,
        arrows: false,
        slidesToShow: 2.5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 500,
      settings: {
        dots: false,
        arrows: false,
        slidesToShow: 1.5,
        slidesToScroll: 1,
      },
    },
  ],
});

$('.article-featured-collection-slider').slick({
  dots: true,
  infinite: false,
  touchThreshold: 10,
  nextArrow:
    '<svg class="related_products_slider_arrow_right slick-arrow slick-disabled" width="12px" height="21px" viewBox="0 0 12 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><!-- Generator: Sketch 63.1 (92452) - https://sketch.com --><title>Path 4</title><desc>Created with Sketch.</desc><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="D-/-Slider" transform="translate(-1322.000000, -216.000000)" stroke="#000000" stroke-width="2"><g id="Slider"><g id="Right-Arrow" transform="translate(1315.000000, 214.000000)"><polyline id="Path-4" transform="translate(13.000000, 12.500000) scale(-1, 1) rotate(-90.000000) translate(-13.000000, -12.500000) " points="4 17 13 8 22 17"></polyline></g></g></g></g></svg>',
  prevArrow:
    '<svg class="related_products_slider_arrow_left slick-arrow slick-disabled" width="12px" height="21px" viewBox="0 0 12 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><!-- Generator: Sketch 63.1 (92452) - https://sketch.com --><title>Path 4</title><desc>Created with Sketch.</desc><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="D-/-Slider" transform="translate(-6.000000, -216.000000)" stroke="#000000" stroke-width="2"><g id="Slider"><g id="Left-Arrow" transform="translate(12.500000, 226.500000) scale(-1, 1) translate(-12.500000, -226.500000) translate(0.000000, 214.000000)"><polyline id="Path-4" transform="translate(13.000000, 12.500000) scale(-1, 1) rotate(-90.000000) translate(-13.000000, -12.500000) " points="4 17 13 8 22 17"></polyline></g></g></g></g></svg>',
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        dots: false,
        arrows: false,
        slidesToShow: 2.5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 500,
      settings: {
        dots: false,
        arrows: false,
        slidesToShow: 1.5,
        slidesToScroll: 1,
      },
    },
  ],
});
$('.brands_logo').slick({
  dots: false,
  infinite: false,
  touchThreshold: 10,
  nextArrow:
    '<svg class="related_products_slider_arrow_right slick-arrow slick-disabled" width="12px" height="21px" viewBox="0 0 12 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><!-- Generator: Sketch 63.1 (92452) - https://sketch.com --><title>Path 4</title><desc>Created with Sketch.</desc><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="D-/-Slider" transform="translate(-1322.000000, -216.000000)" stroke="#000000" stroke-width="2"><g id="Slider"><g id="Right-Arrow" transform="translate(1315.000000, 214.000000)"><polyline id="Path-4" transform="translate(13.000000, 12.500000) scale(-1, 1) rotate(-90.000000) translate(-13.000000, -12.500000) " points="4 17 13 8 22 17"></polyline></g></g></g></g></svg>',
  prevArrow:
    '<svg class="related_products_slider_arrow_left slick-arrow slick-disabled" width="12px" height="21px" viewBox="0 0 12 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><!-- Generator: Sketch 63.1 (92452) - https://sketch.com --><title>Path 4</title><desc>Created with Sketch.</desc><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="D-/-Slider" transform="translate(-6.000000, -216.000000)" stroke="#000000" stroke-width="2"><g id="Slider"><g id="Left-Arrow" transform="translate(12.500000, 226.500000) scale(-1, 1) translate(-12.500000, -226.500000) translate(0.000000, 214.000000)"><polyline id="Path-4" transform="translate(13.000000, 12.500000) scale(-1, 1) rotate(-90.000000) translate(-13.000000, -12.500000) " points="4 17 13 8 22 17"></polyline></g></g></g></g></svg>',
  slidesToShow: 5.5,
  slidesToScroll: 2.5,
  lazyLoad: 'progressive',
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        dots: false,
        arrows: false,
        slidesToShow: 3.5,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 500,
      settings: {
        dots: false,
        arrows: false,
        slidesToShow: 2.5,
        slidesToScroll: 1,
      },
    },
  ],
});
$(document).on('click', '.variants .swatch-element.color', function (e) {
  e.preventDefault();
  var count = 0;
  $(this)
    .closest('.variants')
    .find('.swatch-element.color label')
    .removeClass('checked');
  var col_val = $(this).attr('data-value-handle');
  var col_img = $(this).find('label').attr('data-variant-minicart-image');
  $(this).parents('.pro_feature').find('.img_bg img').attr('src', col_img);
  $(this).find('label').addClass('checked');
  var sizeoption = $(this)
    .parents('.variants')
    .find("[data-option-index='1'] .swatch-element");
  $(sizeoption)
    .removeClass('soldout')
    .removeClass('available')
    .removeClass('soldout-none')
    .removeClass('hide-it');
  $(sizeoption).each(function () {
    var siz_val = $(this).attr('data-value-handle');
    var mer = col_val + '-' + siz_val;
    var id = '#' + mer;
    if ($(this).parents('.variants').find(id).length > 0) {
      $(this).addClass('available');
      count++;
    } else {
      $(this).addClass('soldout');
      $(this).addClass('soldout-none');
    }
    // console.log(mer);
  });
  if (count <= 1) {
    console.log($(this));
    $("[data-option-index='1'] .swatch-element.available").addClass('hide-it');
  }
});

$(document).ready(function () {
  $('.feature-products').each(function () {
    var count = 0;
    var col_load = $(this).find('.swatch-element.color');
    var col_val = $(col_load).attr('data-value-handle');

    var sizeoption = $(col_load)
      .parents('.variants')
      .find("[data-option-index='1'] .swatch-element");
    $(sizeoption)
      .removeClass('soldout')
      .removeClass('available')
      .removeClass('soldout-none')
      .removeClass('hide-it');
    $(sizeoption).each(function () {
      var siz_val = $(this).attr('data-value-handle');
      var mer = col_val + '-' + siz_val;
      var id = '#' + mer;
      if ($(this).parents('.variants').find(id).length > 0) {
        $(this).addClass('available');
        count++;
      } else {
        $(this).addClass('soldout');
        $(this).addClass('soldout-none');
      }
      // console.log(mer);
    });
    if (count <= 1) {
      // console.log($(this))
      $(this)
        .find("[data-option-index='1'] .swatch-element.available")
        .addClass('hide-it');
    }
  });
});

$('.add_cart').hover(
  function () {
    $(this).css('display', 'none');
    $(this).siblings(".swatch[data-option-index='1']").addClass('on_h');
  },
  function () {
    $(this).css('display', 'block');
    $(this).siblings(".swatch[data-option-index='1']").removeClass('on_h');
  }
);

$(".swatch[data-option-index='1']").hover(
  function () {
    $(this).addClass('on_h');
    $(this).siblings('.add_cart').find('.btn').css({
      'background-color': '#030fde',
      'border-color': '#030fde',
      color: '#2ed6c4',
    });
  },
  function () {
    $(this).removeClass('on_h');
    $(this).siblings('.add_cart').find('.btn').css({
      'background-color': '#2ed6c4',
      'border-color': '#030fde',
      color: '#030fde',
    });
  }
);

$(document).on('click', '.variants .swatch-element.size', function (e) {
  e.preventDefault();
  var siz_val = $(this).attr('data-value-handle');
  var coloroption = $(this)
    .parents('.variants')
    .find("[data-option-index='0'] .swatch-element.color label.checked");
  var minicart_img = $(coloroption).attr('data-variant-minicart-image');
  var col_val = $(coloroption)
    .parents('.swatch-element ')
    .attr('data-value-handle');
  var color = $(coloroption).parents('.swatch-element ').attr('data-value');
  var size = $(this).attr('data-value');
  var title = $(this).parents('.pro_feature').find('.p_title').text();
  // var price = $(this).parents(".pro_feature").find(".main_price").attr("data-price");
  var mer = col_val + '-' + siz_val;
  var ids = '#' + mer;

  if ($(this).parents('.variants').find(ids).length > 0) {
    var val_id = $(ids).val();
    let formData = {
      items: [
        {
          id: val_id,
          quantity: 1,
          img_url: minicart_img,
          color: color,
          size: size,
          title: title,
        },
      ],
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        response.json();
        $.getJSON('/cart', function (res) {
          var total_prices = res.total_price;
          var total_quantity = res.item_count;

          total_prices = total_prices / 100.0;
          console.log(total_prices);

          $('body').addClass('minicart-open');
          //  console.log(JSON.stringify(formData));
          $('.minicart-open .subtotal-items span').text(total_quantity);
          $('.minicart-open .subtotal-money').text('$' + total_prices);
          $('.header__cart-container span').text(total_quantity);
          $('.minicart-open .js-selectedOptionTitle').text(title);
          $('.minicart-open .js-selectedOptionName-0').text('Color: ');
          $('.minicart-open .js-selectedOption-0').html(color);

          $('.minicart-open .js-selectedOptionName-1').html('Shoe Size: ');
          $('.minicart-open .js-selectedOption-1').html(size);
          $('.js-variantImage').attr('src', minicart_img);
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
});

$('#shopify-section-collection-landing-page .js-closeMinicart').click(
  function () {
    $('body').removeClass('minicart-open');
  }
);

$(document).ready(function () {
  if ($('.dailyOffers').length > 0) {
    const toggleDailyOffers = function () {
      let scrollOffset = $(document).scrollTop();
      if (scrollOffset > 10) {
        $('.dailyOffers').addClass('active');
      } else {
        if (!$('.dailyOffers').hasClass('expanded')) {
          $('.dailyOffers').removeClass('active');
        }
      }
    };

    const toggleDailyOffersCarousel = function () {
      if ($(window).width() >= 1024) {
        if ($('.dailyOffers_carouselInner').hasClass('slick-initialized')) {
          $('.dailyOffers_carouselInner').slick('unslick');
        }
      } else {
        if (!$('.dailyOffers_carouselInner').hasClass('slick-initialized')) {
          $('.dailyOffers_carouselInner').slick({
            dots: true,
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 2,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ],
          });
        }
      }
    };

    toggleDailyOffers();
    toggleDailyOffersCarousel();

    $(document).on('scroll', function () {
      toggleDailyOffers();
    });

    $(document).on('click', '.dailyOffers__toggler', function () {
      let scrollOffset = $(document).scrollTop();

      $('.dailyOffers').toggleClass('expanded');

      if (!$('.dailyOffers').hasClass('expanded')) {
        toggleDailyOffers();
      }
    });

    $(document).on('click', '.dailyOffers__overlay', function () {
      $('.dailyOffers').removeClass('expanded');
      toggleDailyOffers();
    });

    $(window).on('resize', function () {
      toggleDailyOffersCarousel();
    });
  }
});

$(document).ready(function () {
  $('.announcement-bar__slides').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: '[data-next-arrow]',
    prevArrow: '[data-prev-arrow',
  });

  const arrowsArray = document.querySelectorAll('[data-announcement-arrow]');
  arrowsArray.forEach((arrow) => {
    arrow.addEventListener('click', () => {
      $('.announcement-bar__slides').slick(
        'slickSetOption',
        'autoplay',
        false,
        false
      );
    });
  });
});

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector(
      'AddressCountryNew',
      'AddressProvinceNew',
      {
        hideElement: 'AddressProvinceContainerNew',
      }
    );
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function () {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector,
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function () {
    $newAddressForm.toggleClass('hide');
    $('.addresses__container_main').toggleClass('hide');
    $(window).scrollTop(0);
  });

  $('.address-edit-toggle').on('click', function () {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
    $('.addresses__container_main').toggleClass('hide');
    $(window).scrollTop(0);
  });

  $('.address-delete').on('click', function () {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (
      confirm(confirmMessage || 'Are you sure you wish to delete this address?')
    ) {
      Shopify.postLink('/account/addresses/' + formId, {
        parameters: { _method: 'delete' },
      });
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink',
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/**
 * Index Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Index template.
 *
 * @namespace index
 */
theme.index = (function () {
  // Initializing slick slider
  $('.slideshow').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    slidesToShow: 1,
    speed: 500,
    dots: true,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          fade: false,
        },
      },
    ],
  }); // function
  $('.top_slider').slick({
    autoplay: true,
    pauseOnHover: false,
    autoplaySpeed: 3000,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 500,
    dots: false,
    arrows: false,
    rows: 0,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          initialSlide: 1,
        },
      },
    ],
  });
  $('.bottom_slider').slick({
    rtl: true,
    autoplay: true,
    pauseOnHover: false,
    autoplaySpeed: 3000,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 500,
    dots: false,
    arrows: false,
    rows: 0,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
})();

site = {
  browserWidth: 0,
  setBrowserWidth: function () {
    site.browserWidth =
      window.innerWidth || document.documentElement.clientWidth;
  },
  initNavigation: function () {
    var $nav = $('.js-nav');
    var $navToggle = $('.js-navToggleBtn');

    var $submenuToggle = $('.js-submenuBtn');
    var $submenu = $('.js-submenu');
    var $submenuItem = $('.js-submenuItem');

    var navTopItem = document.getElementById('js-navTop');
    var navTop = $(navTopItem).height();
    var header = document.getElementById('js-header');
    var headerHeight = $(header).height();
    var headerNavHeight = $(header).outerHeight(true);

    $navToggle.on('click', toggleNav);
    $submenuToggle.on('click', openSubMenu);
    //$submenuItem.on("click", openSubMenu);
    $submenuItem.hoverIntent({ over: dropDown, out: dropUp, timeout: 200 });

    function toggleNav(event) {
      if (site.browserWidth < 1199) {
        event.preventDefault();

        $nav.toggleClass('is-active');
        $('body').toggleClass('nav-active');
        $navToggle.toggleClass('is-active');

        if ($navToggle.hasClass('is-active')) {
          $navToggle.attr('aria-expanded', 'true');

          $('.js-searchForm').css('margin-top', 'calc(' + navTop + 'px - 1px)');

          $('.js-submenuBtnFirst').addClass('is-active');
          $('.js-submenuFirst').addClass('is-open');
        } else {
          $navToggle.attr('aria-expanded', 'false');
          $('.js-submenuBtnFirst').removeClass('is-active');
          $('.js-submenuFirst').removeClass('is-open');

          $($submenuItem).removeClass('is-active');
          $($submenuToggle).removeClass('is-active');
          $($submenuToggle).attr('aria-expanded', 'false');
          $($submenu).removeClass('is-open');
        }
      }
    }

    function openSubMenu(event) {
      if (site.browserWidth < 1199) {
        event.preventDefault();
        //console.log('here');
        $($submenuToggle).attr('aria-expanded', 'false');
        $(this).toggleClass('is-active');

        $(this).next($submenu).toggleClass('is-open');
        $(this).parent($submenuItem).toggleClass('is-active');

        if ($(this).hasClass('is-active')) {
          $(this).attr('aria-expanded', 'true');
        } else {
          $(this).attr('aria-expanded', 'false');
        }
      }
    }

    function dropDown() {
      if (site.browserWidth >= 1199) {
        //console.log(headerHeight);
        //console.log(navTop);
        $($submenuToggle).attr('aria-expanded', 'false');
        $(this)
          .children('.js-submenuBtn')
          .first()
          .addClass('is-active')
          .attr('aria-expanded', 'true')
          .next('.js-submenu')
          .addClass('is-open')
          .css('top', headerNavHeight + 'px');
      }
    }
    function dropUp() {
      if (site.browserWidth >= 1199) {
        $(this)
          .children('.js-submenuBtn')
          .first()
          .removeClass('is-active')
          .attr('aria-expanded', 'false')
          .next('.js-submenu')
          .removeClass('is-open')
          .css('top', '0px');
      }
    }
  },
  initAppendAround: function () {
    $('.js-appendaroundContent').appendAround();
  },
  initToggleContent: function () {
    $('.js-toggleBtn').on('click', function (e) {
      $(this).next('.js-toggleContent').slideToggle();
      $(this).toggleClass('is-open');
      e.preventDefault();
    });
  },
  initToggleSearch: function () {
    var $nav = $('.js-nav');
    var navHeight = $($nav).height();
    $('.js-toggleSearchBtn').on('click', function (e) {
      $(this).toggleClass('is-open');
      $('.js-toggleSearchForm').toggleClass('is-open');
      $('.js-toggleSearchForm').css('top', navHeight + 'px');

      var input = document.getElementById('searchBoost4T');
      setTimeout(function () {
        $(input).focus();
      }, 500);
      e.preventDefault();
    });

    $(document).on('click', function (e) {
      if (!$(e.target).closest('.js-toggleSearchForm,.is-open').length) {
        $('body').find('.js-toggleSearchForm').removeClass('is-open');
        $('body').find('.js-toggleSearchBtn').removeClass('is-open');
      }
    });
  },
  initFormValidate: function () {
    $('.js-newsletterFormContainer form').validate({
      rules: {
        'contact[email]': {
          required: true,
          email: true,
        },
      },
      messages: {
        'contact[email]': {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.',
        },
      },
      errorPlacement: function (error, element) {
        error.insertBefore('.input-group');
      },
    });

    $('.js-contactForm form#contact_form').validate({
      rules: {
        'contact[firstname]': {
          required: true,
        },
        'contact[email]': {
          required: true,
          email: true,
        },
        'contact[body]': {
          required: true,
        },
      },
      messages: {
        'contact[firstname]': {
          required: 'Please enter your first name.',
        },
        'contact[email]': {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.',
        },
        'contact[body]': {
          required: 'Please provide a brief message.',
        },
      },
    });
    $(
      '.js-signupForm form#create_customer, #CustomerLoginForm form#customer_login, form#activate_customer_password'
    ).validate({
      rules: {
        'customer[firstname]': {
          required: true,
        },

        'customer[email]': {
          required: true,
          email: true,
        },
        'customer[password]': {
          required: true,
        },
      },
      messages: {
        'customer[firstname]': {
          required: 'Please enter your first name.',
        },
        'customer[email]': {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.',
        },
        'customer[password]': {
          required: 'Please enter a password.',
        },
      },
    });
    $('#RecoverPasswordForm form').validate({
      rules: {
        email: {
          required: true,
          email: true,
        },
      },
      messages: {
        email: {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.',
        },
      },
    });
  },
  initLazyload: function () {
    var $target = $('.lazy');
    function checkElement() {
      var $windowBottom = $(this).scrollTop() + $(this).innerHeight();
      $target.each(function () {
        var $objectBottom = $(this).offset().top + $(this).outerHeight() / 10;
        if ($objectBottom < $windowBottom) {
          $(this).addClass('fade');
        } else {
          $(this).removeClass('fade');
        }
      });
    }
    checkElement();
    $(window).on('scroll', checkElement);
  },
  initSlickSlider: function () {
    $('.js-recommendedProducts').slick({
      dots: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      nextArrow:
        '<button type="button" class="slick-arrow slick-next btn"><svg width="12" height="21" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 21" aria-hidden="true"><path d="M10.5 19.5l-9-9 9-9" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/></svg><span class="visually-hidden">Next</span></button>',
      prevArrow:
        '<button type="button" class="slick-arrow slick-prev btn"><svg width="12" height="21" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 21" aria-hidden="true"><path d="M10.5 19.5l-9-9 9-9" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/></svg><span class="visually-hidden">Previous</span></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
          },
        },
      ],
    });

    $('.js-recommendedProductsMiniCart').slick({
      dots: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: false,
    });

    $('.js-slickSlideProdImages').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      dots: false,
      lazyLoad: 'ondemand',
      asNavFor: '.js-slickSlideProdThumbs',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            dots: true,
          },
        },
      ],
    });

    $('.js-slickSlideProdThumbs').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.js-slickSlideProdImages',
      focusOnSelect: true,
      nextArrow:
        '<button type="button" class="slick-arrow slick-next btn"><svg width="12" height="21" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 21" aria-hidden="true"><path d="M10.5 19.5l-9-9 9-9" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/></svg><span class="visually-hidden">Next</span></button>',
      prevArrow:
        '<button type="button" class="slick-arrow slick-prev btn"><svg width="12" height="21" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 21" aria-hidden="true"><path d="M10.5 19.5l-9-9 9-9" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/></svg><span class="visually-hidden">Previous</span></button>',
    });
  },
  initModal: function () {
    // $('.js-sizeChartBtn').on('click',function(e){
    //     e.preventDefault();
    //     var url = $(this).attr('href');
    //     $.ajax(url, {
    //         dataType: 'html',
    //         cache : false,
    //         success: function(data) {
    //           $("#modalContent").html('');
    //           $("#modalContent").append(data);
    //           $('body').addClass('size-chart-open nav-active');

    //           $(".js-closeSizeChart").focus();

    //           $('#size-chart').keyup(function(event){
    //           	if (event.keyCode == 27){
    //           		// Close the modal/menu
    //           		closeModal();

    //                   //  Return focus to the element that invoked it
    //           		$('.js-sizeChartBtn').focus();
    //           	}
    //           });
    //         }
    //     });

    // });
    $('.js-sizeChartBtn').each(function (index) {
      $(this).on('click', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        $.ajax(url, {
          dataType: 'html',
          cache: false,
          success: function (data) {
            $('#modalContent').html('');
            $('#modalContent').append(data);
            $('body').addClass('size-chart-open nav-active');
            $('.js-closeSizeChart').focus();
            $('#size-chart').keyup(function (event) {
              if (event.keyCode == 27) {
                // Close the modal/menu
                closeModal(); //  Return focus to the element that invoked it
                $('.js-sizeChartBtn').focus();
              }
            });
          },
        });
      });
    });
    $('.js-closeSizeChart').on('click', function (e) {
      e.preventDefault();
      closeModal();
    });
    function closeModal() {
      $('body').removeClass('size-chart-open nav-active');
    }
  },
  initListToSelect: function () {
    $selectNav = $('.js-selectNav');

    // Create the dropdown base
    $(
      "<select class='page-nav__select medium-up--hide js-page-nav-select' />"
    ).appendTo($selectNav);
    // Create the dropdown base

    // Populate dropdown with menu items
    $($selectNav)
      .find('a')
      .each(function () {
        var $item = $(this),
          $selected = $item.hasClass('current');
        $('<option />', {
          value: $item.attr('href'),
          text: $item.text(),
          selected: $selected,
        }).appendTo('.js-page-nav-select');
      });

    $selectNav.on('change', function () {
      $selectedNav = $('.js-page-nav-select option:selected');

      if ($selectedNav !== '') {
        window.location.href = $selectedNav.val();
      }
    });
  },
  run: function () {
    site.setBrowserWidth();
    site.initNavigation();
    site.initAppendAround();
    site.initToggleContent();
    site.initToggleSearch();
    site.initFormValidate();
    site.initLazyload();
    site.initSlickSlider();
    site.initModal();
    site.initListToSelect();
  },
  helpers: {
    debounce: function (func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },
  },
};

$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper',
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className =
      document.documentElement.className.replace(
        'supports-no-cookies',
        'supports-cookies'
      );
  }

  var triggerResize = site.helpers.debounce(function () {
    if ($(this).width() != site.browserWidth) {
      site.setBrowserWidth();
    }
  }, 250);

  site.run();
  window.addEventListener('resize', triggerResize);

  /*
    jQuery(function() {
      jQuery('.swatch :radio').change(function() {
        var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
        var optionValue = jQuery(this).val();

        jQuery(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');
        jQuery('.js-selectedOption').html(optionValue);
      });
      jQuery('.swatch label').keydown(function (e) {
          if (e.keyCode == 13) {
              console.log('here');
              var labelID = $(this).attr('for');
              $('#'+labelID).trigger('click');
          }


      });
    });
*/
  jQuery(function () {
    jQuery('.swatch :radio').change(function () {
      var optionIndex = jQuery(this)
        .closest('.swatch')
        .attr('data-option-index');
      var optionValue = jQuery(this).val();
      jQuery(this)
        .closest('form')
        .find('.single-option-selector')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');
      var swatchName = jQuery(this)
        .parent()
        .parent()
        .find('.js-selectedOption')
        .attr('id');
      jQuery('#' + swatchName + '.js-selectedOption').html(optionValue);
    });
    jQuery('.swatch label').keydown(function (e) {
      if (e.keyCode == 13) {
        console.log('here');
        var labelID = $(this).attr('for');
        $('#' + labelID).trigger('click');
      }
    });
  });
});
